import { render } from "./CoinSwap.vue?vue&type=template&id=181b4f54&scoped=true"
import script from "./CoinSwap.vue?vue&type=script&lang=js"
export * from "./CoinSwap.vue?vue&type=script&lang=js"

import "./CoinSwap.vue?vue&type=style&index=0&id=181b4f54&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181b4f54"]])

export default __exports__